export default class TabOpen {
  constructor() {
    this.setup();
  }
  setup() {
    // data-tab="開きたいTabのID" をhtmlで指定する
    $('[data-tab]').on('click', function() {
      const tabId = $(this).data('tab');
      activaTab(tabId);
    });
    function activaTab(tab) {
      $('.nav a[href="#' + tab + '"]').tab('show');
    }

    // ?tab="遷移先の開きたいTabのID"で外部から直リンク
    // &pos="遷移先表示位置のID"で外部から直リンク後にスクロール
    function getParam(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
    var url = $(location).attr('href');
    if (url.indexOf('?tab=') != -1) {
      var tab = getParam('tab');
      var pos = getParam('pos');
      console.log(tab);
      console.log(pos);
      $('[role="tablist"] a[href="#' + tab + '"]').tab('show');

      var sctoll = $('#' + pos).offset().top - 80;
      $('html, body').animate({scrollTop: sctoll}, 600);
    }
  }
}
